{
    "LicenseManagement_Title": "Enterprise License Management",
    "LicenseManagement_Heading_License": "License - Teams",
    "LicenseManagement_Heading_Quantity": "Quantity",
    "LicenseManagement_Essentials": "Essentials",
    "LicenseManagement_Essentials_WBX": "WxC User",
    "LicenseManagement_Essentials_MST": "CXA Standard",
    "LicenseManagement_Essentials_MSTB": "Historic User",
    "LicenseManagement_Professional": "Professional",
    "LicenseManagement_Professional_WBX": "Professional",
    "LicenseManagement_Professional_MST": "Professional",
    "LicenseManagement_Professional_MSTB": "Real-Time User",
    "LicenseManagement_Enterprise": "Enterprise",
    "LicenseManagement_Enterprise_WBX": "Enterprise",
    "LicenseManagement_Enterprise_MST": "CXA Advanced (Historic)",
    "LicenseManagement_Enterprise_MSTB": "Enterprise",
    "LicenseManagement_CallCentreAgent": "Call Center Agent",
    "LicenseManagement_CallCentreAgent_WBX": "WxC Agent",
    "LicenseManagement_CallCentreAgent_MST": "CXA Premium",
    "LicenseManagement_CallCentreAgent_MSTB": "Agent",
    "LicenseManagement_CallCentreSupervisor": "Call Center Supervisor",
    "LicenseManagement_CallCentreSupervisor_WBX": "WxC Supervisor",
    "LicenseManagement_CallCentreSupervisor_MST": "CXA Advanced",
    "LicenseManagement_CallCentreSupervisor_MSTB": "Manager",
    "LicenseManagement_CXIntegration": "CX Integration",
    "LicenseManagement_Validation_Number": "Must be a valid number",
    "LicenseManagement_Validation_Limit": "Exceeds CME License Cap. Must be less than or equal to {}",
    "LicenseManagement_Validation_Limit_Reached": "Exceeds CME License Cap. No more licenses available",
    "LicenseManagement_Validation_MAX_LIMIT": "Number exceeds maximum allowed number",
    "LicenseManagement_Validation_POSITIVE_NUMBER": "Number must be positive",
    "NAME": "LicenseManagement"
}
